import enUsJson from './content-en-us.json'
import GenericContent from './generic-content.json'
import PageContent from './pages-content.json'

function compareDates(a: TDateLogic, b: TDateLogic) {
	const dateA = new Date(a.date).toLocaleDateString()
	const dateB = new Date(b.date).toLocaleDateString()
	return Date.parse(dateA) - Date.parse(dateB)
}

function getDateContent(date_logic: Array<TDateLogic>) {
	const sortedDates = date_logic.sort(compareDates)
	let dataId = 'data'

	sortedDates.forEach((item) => {
		const today = new Date().toLocaleDateString()
		const future = new Date(item.date).toLocaleDateString()

		if (Date.parse(today) - Date.parse(future) >= 0) dataId = item.content
	})
	return dataId
}

export function getGenericContent(
	contentId: string,
	language = 'en-us',
	fromCms = false
): TGenericContent {
	if (!fromCms && contentId) {
		if (language !== 'en-us') return null

		const result = GenericContent.filter((json) => {
			return json.content_id.toLowerCase() === contentId.toLowerCase()
		})[0]

		if (!result) return null
		return typeof result.data == 'string' || Array.isArray(result.data) ? result.data : null
	}
	return null
}

export function getPageContent(
	contentId: string,
	language = 'en-us',
	fromCms = false
): TGenericContent {
	if (!fromCms && contentId) {
		if (language !== 'en-us') return null

		const result = PageContent.filter((json) => {
			return json.content_id.toLowerCase() === contentId.toLowerCase()
		})[0]

		if (!result) return null
		return typeof result.data == 'string' || Array.isArray(result.data) ? result.data : null
	}
	return null
}

export function getProgram(
	contentId: string,
	language = 'en-us',
	fromCms = false
): TProgramContent {
	if (!fromCms && contentId) {
		if (language !== 'en-us') return null

		const result = enUsJson.filter((json) => {
			return json.content_id.toLowerCase() === contentId.toLowerCase()
		})[0]

		if (typeof result.data == 'string' || Array.isArray(result.data)) return null

		if (result?.date_logic) {
			// @ts-expect-error
			return result?.[getDateContent(result?.date_logic)] ?? result.data ?? null
		} else {
			return result.data ?? null
		}
	}
	return null
}

export const getExitModal = (contentId: string, language = 'en-us', fromCms = false) => {
	if (!fromCms) {
		if (language !== 'en-us') return
		const result = enUsJson.filter(
			(json) => json.content_id.toLowerCase() === contentId.toLowerCase()
		)
		return result.length === 0 ? contentId : result[0]['dataExitModal']
	}
	return contentId
}
